/* global axios */
import ApiClient from '../ApiClient';

class NexceoAiEmployeesAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  show(projectId) {
    return axios.get(`${this.url}/${projectId}/ai_employee`);
  }

  update(projectId, data) {
    return axios.patch(`${this.url}/${projectId}/ai_employee`, data);
  }

  testMessage(projectId, message) {
    return axios.post(`${this.url}/${projectId}/ai_employee/test_message`, {
      message,
    });
  }
}

export default new NexceoAiEmployeesAPI();
